var exports = {
  "iE": "x804f0401--c0e9b2--wrapper",
  "kL": "x804f0401--c0e9b2--container",
  "AS": "x804f0401--c0e9b2--item",
  "UE": "x804f0401--c0e9b2--arrow",
  "qY": "x804f0401--c0e9b2--left-arrow",
  "JO": "x804f0401--c0e9b2--right-arrow",
};

module.exports = exports;
